import { add } from 'date-fns';

import { Currency } from '@/generated/gql/graphql.ts';
import { coaleseDecimal } from '~/util/number/coaleseDecimal.ts';

import { IntakeQuoteFormData, intakeQuoteFormDataDefault, IntakeQuoteLineItem } from './IntakeQuoteStep.schema.ts';
import { IntakeQuote, IntakeQuoteInput, IntakeQuoteLineItemGridRow } from './IntakeQuoteStep.types.ts';

const toLineItemSchemaData = (lineItems?: IntakeQuoteLineItemGridRow[] | null): IntakeQuoteLineItem[] => {
  return (
    lineItems?.map(
      ({
        id,
        position,
        title,
        commodityGroupId,
        description,
        earlyDeliveryAt,
        lateDeliveryAt,
        pricePerUnit,
        quantity,
        unitId,
        sequence,
      }) => {
        return {
          id,
          position,
          sequence,
          title: title ?? '',
          commodityGroupId: commodityGroupId ?? '',
          description: description ?? '',
          earlyDeliveryAt: earlyDeliveryAt ? new Date(earlyDeliveryAt) : null,
          lateDeliveryAt: lateDeliveryAt ? new Date(lateDeliveryAt) : add(new Date(), { days: 14 }),
          pricePerUnit: coaleseDecimal(pricePerUnit),
          quantity: coaleseDecimal(quantity),
          unitId: unitId ?? '',
        };
      },
    ) ?? []
  );
};

export const toFormSchemaData = (data?: IntakeQuote | null): IntakeQuoteFormData => {
  return {
    ...intakeQuoteFormDataDefault,
    ...data,
    id: data?.id ?? '',
    lineItems: toLineItemSchemaData(data?.lineItems),
    currency: (data?.currency as unknown as Currency) ?? Currency.EUR,
    quoteReference: data?.quoteReference ?? '',
  };
};

export const toGraphqlFormat = (sessionId: string, formData: IntakeQuoteFormData): { data: IntakeQuoteInput } => {
  const { lineItems } = formData;

  const data = {
    chatSessionId: sessionId,
    id: formData.id,
    quoteReference: formData.quoteReference,
    lineItems: lineItems.map(({ pricePerUnit, quantity, ...lineItem }, index) => ({
      ...lineItem,
      pricePerUnit: pricePerUnit?.toString() ?? '0',
      quantity: quantity.toString(),
      sequence: index + 1,
    })),
  } satisfies IntakeQuoteInput;

  return {
    data,
  };
};
